import { useContext, useState } from 'react';
import { useMutation } from '@apollo/client/react';
import * as R from 'ramda';

import AddFormsModal from '@atom/components/common/workOrderDetail/addFormsModal/AddFormsModal';
import WorkTemplateContext from '@atom/components/workTemplate/WorkTemplateContext';
import { WORK_TEMPLATE_TASK_FORM_TEMPLATE_CREATE } from '@atom/graph/workTemplate';
import { Icon, IconButton } from '@atom/mui';
import {
  AddIcon,
  ExpandLessIcon,
  ExpandMoreIcon,
  LibraryBooksIcon,
} from '@atom/mui/icons';
import {
  doesNotHaveRolePermissions,
  ROLE_SETS,
} from '@atom/utilities/authUtilities';

import FormTile from './FormTile';

import classes from './formSection.module.css';

const FormSection = () => {
  const { workTemplate, refetch, task, loading } =
    useContext(WorkTemplateContext);

  const [expanded, setExpanded] = useState<boolean>(true);
  const [open, setOpen] = useState<boolean>(false);

  const [addForms] = useMutation(WORK_TEMPLATE_TASK_FORM_TEMPLATE_CREATE, {
    onCompleted: res => refetch(),
  });

  const handleAddForm = async (formTemplateIds: string[]) => {
    await addForms({
      variables: {
        input: {
          workTemplateId: workTemplate.id,
          taskId: task.id,
          formTemplateIds,
        },
      },
    });

    setOpen(false);
  };

  const isSectionEmpty = R.isEmpty(task?.formTemplates);
  const totalCount = R.length(task?.formTemplates) || 0;
  const icon = expanded ? ExpandLessIcon : ExpandMoreIcon;
  const isDisabled =
    workTemplate?.published || doesNotHaveRolePermissions(ROLE_SETS.ORG_ADMIN);

  return (
    <>
      <div className={classes.sectionContainer}>
        <Icon icon={LibraryBooksIcon} />
        <div className={classes.sectionTitle}>Forms</div>
        <div className={classes.totalCount}>{totalCount}</div>
        <div className={classes.buttonsContainer}>
          {expanded && (
            <IconButton
              onClick={() => setOpen(true)}
              edge="end"
              tooltip="Add Forms"
              disabled={isDisabled}
            >
              <Icon icon={AddIcon} />
            </IconButton>
          )}
          <IconButton onClick={() => setExpanded(!expanded)} edge="end">
            <Icon icon={icon} />
          </IconButton>
        </div>
      </div>
      {expanded && (
        <div className={classes.tileList}>
          {isSectionEmpty ? (
            <div className={classes.emptySectionText}>Add Forms</div>
          ) : (
            <>
              {task.formTemplates.map(formTemplate => (
                <FormTile key={formTemplate.id} formTemplate={formTemplate} />
              ))}
            </>
          )}
        </div>
      )}
      <AddFormsModal
        schemaId={workTemplate?.schemaId}
        loading={loading}
        open={open}
        onClose={() => setOpen(false)}
        handleAddForm={handleAddForm}
      />
    </>
  );
};

export default FormSection;
